module.exports = __webpack_public_path__ + "img/moon.9134906c.png";